import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TokenizeDialogComponent } from '../../../components/tokenize/tokenize-dialog/tokenize-dialog.component';
import { TextModes } from '../../../components/ui/controls/text-input/text-input.component';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { Customer } from '../../../models/customer/customer';
import { CustomerService } from '../../../models/customer/customerService';
import { PaymentMethod } from '../../../models/paymentMethod/paymentMethod';
import { PaymentMethodService } from '../../../models/paymentMethod/paymentMethodService';
import { TokenizeFormComponent } from '../tokenize-form/tokenize-form.component';
import { AdminService } from '../../../models/admin/adminService';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';
@Component({
  selector: 'app-terminal-billing-form',
  templateUrl: './terminal-billing-form.component.html',
  standalone: false,
})
export class TerminalBillingFormComponent {
  @Input() merchantId: string | undefined;
  @Input() customerId: string | undefined;
  @Input() selectedPaymentMethodId: string | undefined;
  @Input() inlineMode: boolean = false;
  @Input() achEnabled: boolean = false;
  @Input() selectedPaymentType: number = 1;

  @Output() onValidationChange = new EventEmitter<boolean>();
  @Output() onSelectedPaymentMethod = new EventEmitter<Partial<PaymentMethod>>();
  // @Output() onAmountChange = new EventEmitter<number>();
  @Output() onTokenized = new EventEmitter<string>();

  @ViewChild(TokenizeFormComponent) tokenizeForm:
    | TokenizeFormComponent
    | undefined;

  readonly NEW_PAYMENT_METHOD_OPTION_ID = 'new';
  readonly paymentOptionRadioName = 'terminal-payment-option';

  paymentMethods: PaymentMethod[] = [];
  paymentMethodsOptions: ListItem[] = [];
  newPaymentMethodOptions: ListItem[] = [
    new ListItem({
      id: this.NEW_PAYMENT_METHOD_OPTION_ID,
      name: 'Add a new payment method',
    }),
  ];
  selectedPaymentMethod: PaymentMethod | undefined;
  selectedPaymentOptionId: string | undefined;
  allowPaymentMethodChange: boolean = true;
  addingNewPaymentMethod: boolean = false;

  inputTextModes = TextModes;


  //Need to move these into a shared enum/constant file
  MODE_CREDIT_CARD = 1;
  MODE_ECHECK = 2;
  MODE_INVOICE = 3;


  //Feature Flags
  achPaymentMethodFlagEnabled: boolean = false;

  constructor(
    public customerService: CustomerService,
    public paymentMethodService: PaymentMethodService,
    public router: Router,
    public addPaymentMethodDialog: MatDialog,
    private uiErrorHandler: UIErrorHandler,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      merchantId: string;
    },
  ) {}

  ngOnInit() {
    this.adminService
      .getFeatureFlagByName('achPaymentMethod')
      .then((enabled) => {
        this.achPaymentMethodFlagEnabled = enabled;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    let customerIdChange = changes['customerId'];

    if (customerIdChange) {
      this.selectedPaymentOptionId = undefined;
      this.addingNewPaymentMethod = false;

      if (customerIdChange.currentValue) {
        //this.loadCustomerInfo(customerIdChange.currentValue, false);
        this.tokenizeForm?.updateCustomerId(this.customerId);
        this.loadPaymentMethods();
      } else {
        this.customerId = undefined;
        this.tokenizeForm?.updateCustomerId('');
        this.paymentMethods = [];
        this.paymentMethodsOptions = [];
      }
      return;
    }

    if (changes['selectedPaymentMethodId']) {
      this.applySelectedPaymentMethodId();
    }
  }

  public refresh() {
    if (this.tokenizeForm?.paymentType) {
      if (this.selectedPaymentType == this.MODE_ECHECK) {
        this.tokenizeForm!.paymentType = 'ACH';
      } else {
        this.tokenizeForm!.paymentType = 'Card';
      }
    }
    this.tokenizeForm?.reloadframe();
  }

  public clear() {
    this.selectedPaymentOptionId = undefined;
    this.selectedPaymentMethodId = undefined;
    this.selectedPaymentMethod = undefined;
    this.addingNewPaymentMethod = false;
    this.clearSelection();
    this.customerId = undefined;
  }

  public clearSelection() {
    this.tokenizeForm?.clearForm();
  }

  public tokenize() {
    if (this.tokenizeForm) {
      this.tokenizeForm?.tokenize();
    } else {
      throw 'tokenize form is not initialized';
    }
  }

  // Do we need this? We are already passing in a selected payment method id as @Input()
  public setPaymentMethod(paymentMethodId: string, customerId: string) {
    this.paymentMethodService
      .getPaymentMethod(paymentMethodId, customerId)
      .then((pm) => {
        this.selectedPaymentMethod = pm;
        this.allowPaymentMethodChange = false;
      });
  }

  // btnNewPaymentMethod_click(type: string) {
  //   let ref = this.addPaymentMethodDialog.open(TokenizeDialogComponent, {
  //     //width: '500px',
  //     disableClose: false,
  //     data: {
  //       merchantId: this.merchantId,
  //       customerId: this.customerId,
  //       paymentType: type,
  //     },
  //   });

  //   this.router.events.subscribe(() => {
  //     ref.close();
  //   });

  //   ref.afterClosed().subscribe((paymentMethodId) => {
  //     if (paymentMethodId != undefined && paymentMethodId != '') {
  //       this.loadPaymentMethods().then(() => {
  //         this.selectPaymentMethod_click(paymentMethodId, '');
  //       });
  //     }
  //   });
  // }

  handleTokenizeFormValidationChanged(data: any) {
    this.onValidationChange.emit(data);

    if (this.selectedPaymentMethod) {
      var pm = document.getElementById('#pm_' + this.selectedPaymentMethod?.id);
      if (pm) {
        pm.classList.replace('selected', '');
      }

      this.onSelectedPaymentMethod.emit(this.selectedPaymentMethod);
      this.selectedPaymentMethod = undefined;
    }
  }

  handleTokenized(tokenizationData: any) {
    const paymentMethodId = tokenizationData?.paymentMethodId as string;
    if (!paymentMethodId) {
      return;
    }
    
    this.onTokenized.emit(tokenizationData.paymentMethodId as string);
  }

  onSavePaymentMethodClicked(): void {
    this.tokenizeForm?.tokenize();
  }

  onPaymentOptionChanged(optionId: string | undefined): void {
    this.selectedPaymentOptionId = optionId;

    if (optionId === this.NEW_PAYMENT_METHOD_OPTION_ID) {
      this.selectedPaymentMethodId = undefined;
      this.selectedPaymentMethod = undefined;
      this.addingNewPaymentMethod = true;
      this.onSelectedPaymentMethod.emit(undefined);
      setTimeout(() => this.tokenizeForm?.sendMessageToPaymentForm('ping'));
      this.tokenizeForm?.reloadframe();
      return;
    }

    this.addingNewPaymentMethod = false;
    this.selectedPaymentMethodId = optionId;
    this.selectedPaymentMethod = optionId
      ? this.getPaymentMethodFromId(optionId)
      : undefined;

    this.onSelectedPaymentMethod.emit(this.selectedPaymentMethod);
  }

  selectPaymentMethod_click(paymentMethodId: string | undefined, paymentMethodName: string): void {
    if (paymentMethodId !== undefined) {
      if (paymentMethodId == this.selectedPaymentMethod?.id) {
        this.selectedPaymentMethod = undefined;
        paymentMethodId = undefined;
      } else {
        this.selectedPaymentMethod = this.getPaymentMethodFromId(paymentMethodId);
      }
    } else {
      this.selectedPaymentMethod = undefined;
    }

    this.onPaymentOptionChanged(paymentMethodId);
  }

  private applySelectedPaymentMethodId(): boolean {
    if (
      !this.selectedPaymentMethodId ||
      !this.getPaymentMethodFromId(this.selectedPaymentMethodId)
    ) {
      return false;
    }

    if (this.selectedPaymentOptionId !== this.selectedPaymentMethodId) {
      this.onPaymentOptionChanged(this.selectedPaymentMethodId);
    }

    return true;
  }

  getPaymentMethodFromId(id: string): PaymentMethod | undefined {
    if (this.paymentMethods != null) {
      for (var i = 0; i < this.paymentMethods.length; i++) {
        if (this.paymentMethods[i].id == id) {
          return this.paymentMethods[i];
        }
      }
    }

    return undefined;
  }

  async loadPaymentMethods() {
    if (this.customerId) {
      await this.paymentMethodService
        .getPaymentMethodsByCustomerId(this.customerId)
        .then((pms) => {
          if (this.selectedPaymentType == this.MODE_CREDIT_CARD) {
            this.paymentMethodsOptions = pms.filter(pm => pm.nickname == "").map(
              (pm) =>
                new ListItem({
                  id: pm.id,
                  name: pm.cardType + ' ********' + pm.cardLast4,
                }),
            );
          }
          else if (this.selectedPaymentType == this.MODE_ECHECK) {
            this.paymentMethodsOptions = pms.filter(pm => pm.nickname != "").map(
              (pm) =>
                new ListItem({
                  id: pm.id,
                  name: pm.cardType + ' ********' + pm.cardLast4,
                }),
            );
          }

          // this.paymentMethodsOptions.push(new ListItem({ id: "", name: "Add New Credit Card" }));

          //We say that if the payment method has a nickname, then it is an ACH payment method
          // console.log("loading temp payment method");
          // const tempPaymentMethod = new PaymentMethod({
          //   id: "temp",
          //   tokenizedCardId: "temp",
          //   customerId: this.customerId,
          //   cardType: "Checking",
          //   nickname: "For Mortgage",
          //   nameOnCard: "TEMPACH",
          //   cardExpMonth: "01",
          //   cardExpYear: "02",
          //   cardFirst6: "12",
          //   cardLast4: "3456",
          // });
          // this.paymentMethods = [...pms, tempPaymentMethod];
          this.paymentMethods = pms;
          if (!this.applySelectedPaymentMethodId() && this.inlineMode) {
            this.selectedPaymentMethod = this.paymentMethods[0];
          }
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }

  deletePaymentMethod(paymentMethodId: string) {
    if (confirm('Are you sure you want to delete this payment method?')) {
      this.paymentMethodService
        .deletePaymentMethod(paymentMethodId)
        .then(() => {
          this.loadPaymentMethods();
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }
}
